<template>
  <!-- <div :class="{'navBox': true, 'isHeaderFixed': isFixed}"   :style="{color: school_type == 1 ? '#356FFA' : '#ffffff',background: school_type == 1 ? '#356FFA' : '#2A2D34'}" > -->
  <div :class="{'navBox': true, 'isHeaderFixed': isFixed}"   :style="{color: siteType == 1  ||  school_type== 1  || siteType == 3 ? '#356FFA' : '#ffffff',background: siteType == 1 || school_type== 1 || siteType == 3 ? '#356FFA' : '#2A2D34'}" >
    <!-- 学校-头部 -->
    <div v-if="school_type == 1 && siteType != 1" class="contentBox" :class="[isAiResumeDetail ? 'w-100' : '', isAiResumeResult ? 'dia-width' : '', isAiInterViewResult? 'w-1440' : '']">
      <div class="menuLeft">
        <img :src="schoolIcon" alt="" @click="$router.push('/')">
        <div class="textBox">
          <!-- <p>{{isJYShow ? '云南省2024届高校毕业生' : schoolName}}</p> -->
          <p v-if="siteType == 2 && !showTitle" :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'">{{handlename(schoolName)+'站'}}</p>
          <p v-else :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'">{{handlename(isJYShow ? '云南省2024届高校毕业生' : schoolName)}}</p>
          <p class="pingtai" v-if="siteType == 2 && !showTitle">2025届高校毕业生校园招聘系列活动</p>
          <p class="pingtai" v-else>{{isJYShow ? '“校园招聘月”系列招聘会' : isCQShow ? '2024届毕业生网络招聘会' : '就业育人平台'}}</p>
        </div>
      </div>
      <div class="menuCenter">
        <div :class="{'selectText': $route.meta.activeHome == 'home'}" @click="jumpIndex('0')"><span>首页</span></div>
        <div v-if="isOpenAi == 1" :class="{'selectText': $route.meta.activeHome == 'aiResume', 'public_menu_box': true}" @mouseenter="isAiResumeShowMenu = true" @mouseleave="isAiResumeShowMenu = false">
          <span>AI简历</span>
          <div v-if="isAiResumeShowMenu" :class="['p_down_menu animate__animated', isAiResumeShowMenu ? 'animate__fadeIn' : 'fadeOut']">
            <span class="row_menu" @click="jumpIndex('3')">AI智写简历</span>
            <span class="row_menu" @click="jumpIndex('4')">AI简历诊断</span>
          </div>
        </div>
        <div v-if="is_ai_interview == 1" :class="{'selectText': $route.meta.activeHome == 'interviewRoom'}" @click="jumpIndex('5')"><span>AI模拟面试<p class="icon_box">Beta</p></span></div>
        <div v-if="catalogue.position_recommend == 1 " :class="{'selectText': $route.meta.activeHome == 'jobRecommend'}" @click="jumpIndex('1')"><span>职位推荐</span></div>
        <div v-if="catalogue.company_show_all == 1 " :class="{'selectText': $route.meta.activeHome == 'company'}" @click="jumpIndex('2')"><span>企业</span></div>
      </div>
      <div class="menuRight">
        <div class="myResume" :class="{'selectText': false}" @click="jumpMyResume()">我的简历</div>
        <div v-if="!isShowPortrait" class="loginBox">
          <div @click="handleLogin('')">登录/注册</div>
        </div>
        <div v-else class="headPortrait" @mouseover="isShowOutBox = true" @mouseout="isShowOutBox = false">
          <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
          <div class="my-dialog-box" v-show="isShowOutBox">
            <div class="my-basic-info">
              <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
              <span class="name">{{userName}}</span>
            </div>
            <div class="my-function">
              <div class="public-box" @click="jumpDeliveryFeedback">
                <span class="public-icon"></span>
                <span class="name">投递反馈</span>
              </div>
              <div class="public-box" @click="interviewDialogVisible = true">
                <span class="public-icon2"></span>
                <span class="name">我的面试</span>
              </div>
              <div class="public-box" @click="jumpMyCollect">
                <span class="public-icon3"></span>
                <span class="name">我的收藏</span>
              </div>
            </div>
            <div class="backBox" @click="handleBack">
<!--              <i class="iconfont icon-jyyrtuichu"></i>-->
              <span>退出登录</span>
            </div>
          </div>
        </div>
        <!-- <div class="logoinEntr" v-if="$route.meta.isOtherLoginBox"> -->
        <div class="logoinEntr" >
          <span @click="handleSchoolDialog">高校后台</span>
          <!-- <span @click="handleCompanyDialog">我要招人</span> -->
          <div style="display:flex;align-items: center;" @mousemove="handlehover" @mouseout="handleOut" @click="handleCompanyDialog">
            <!-- <img src="../../assets/qiye_hover.png" alt=""> -->
            <img v-if="mouseHov" src="../../assets/qiye_hover.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <img v-else src="../../assets/qiye_normal.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <span :style="{color: mouseHov ? '#ffffff' : 'rgba(255,255,255,.8)'}"> 我要招人</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 主站-头部 -->
    <div v-if=" siteType == 1" class="contentBox-mainsite" :class="[isAiResumeDetail ? 'w-100' : '', isAiResumeResult ? 'dia-width' : '', isAiInterViewResult? 'w-1440' : '']">
      <div class="menuLeft">
        <img v-if="!showTitle" src="@/assets/logo-header.png" width="132px" height="36px" alt="" @click="jumpIndex('0')">
        <img v-else src="@/assets/jyyy.png" width="132px" height="36px" alt="" @click="jumpIndex('0')">
        <!-- <div class="textBox">
          <p :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'">{{handlename(isJYShow ? '云南省2024届高校毕业生' : schoolName)}}</p>
          <p class="pingtai">{{isJYShow ? '“校园招聘月”系列招聘会' : isCQShow ? '2023届毕业生网络招聘会' : '就业育人平台'}}</p>
        </div> -->
      </div>
      <div class="menuCenter">
        <div :class="{'selectText': $route.meta.activeHome == 'home'}" @click="jumpIndex('0')"><span>首页</span></div>
        <div v-if="isOpenAi == 1" :class="{'selectText': $route.meta.activeHome == 'aiResume', 'public_menu_box': true}" @mouseenter="isAiResumeShowMenu = true" @mouseleave="isAiResumeShowMenu = false">
          <span>AI简历</span>
          <div v-if="isAiResumeShowMenu" :class="['p_down_menu animate__animated', isAiResumeShowMenu ? 'animate__fadeIn' : 'fadeOut']">
            <span class="row_menu" @click="jumpIndex('3')">AI智写简历</span>
            <span class="row_menu" @click="jumpIndex('4')">AI简历诊断</span>
          </div>
        </div>
        <div v-if="is_ai_interview == 1" :class="{'selectText': $route.meta.activeHome == 'interviewRoom'}" @click="jumpIndex('5')"><span>AI模拟面试<p class="icon_box">Beta</p></span></div>
        <div v-if="catalogue.position_recommend == 1 " :class="{'selectText': $route.meta.activeHome == 'jobRecommend'}" @click="jumpIndex('1')"><span>职位推荐</span></div>
        <div v-if="catalogue.company_show_all == 1 " :class="{'selectText': $route.meta.activeHome == 'company'}" @click="jumpIndex('2')"><span>企业</span></div>
      </div>
      <div class="menuRight">
        <div class="myResume" :class="{'selectText': false}" @click="jumpMyResume()">我的简历</div>
        <div v-if="!isShowPortrait" class="loginBox">
          <div @click="handleLogin('')">登录/注册</div>
        </div>
        <div v-else class="headPortrait" @mouseover="isShowOutBox = true" @mouseout="isShowOutBox = false">
          <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
          <div class="my-dialog-box" v-show="isShowOutBox">
            <div class="my-basic-info">
              <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
              <span class="name">{{userName}}</span>
            </div>
            <div class="my-function">
              <div class="public-box" @click="jumpDeliveryFeedback">
                <span class="public-icon"></span>
                <span class="name">投递反馈</span>
              </div>
              <div class="public-box" @click="interviewDialogVisible = true">
                <span class="public-icon2"></span>
                <span class="name">我的面试</span>
              </div>
              <div class="public-box" @click="jumpMyCollect">
                <span class="public-icon3"></span>
                <span class="name">我的收藏</span>
              </div>
            </div>
            <div class="backBox" @click="handleBack">
<!--              <i class="iconfont icon-jyyrtuichu"></i>-->
              <span>退出登录</span>
            </div>
          </div>
        </div>
        <!-- <div class="logoinEntr" v-if="$route.meta.isOtherLoginBox"> -->
        <div class="logoinEntr" >
          <!-- <span @click="handleCompanyMainsite">我要招人</span> -->
          <!-- 主站--点击我要招人直接打开新的页面 -->
          <div style="display:flex;align-items: center;" @mousemove="handlehover" @mouseout="handleOut"  @click="handleCompanyMainsite">
            <!-- <img src="../../assets/qiye_hover.png" alt=""> -->
            <img v-if="mouseHov" src="../../assets/qiye_hover.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <img v-else src="../../assets/qiye_normal.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <span :style="{color: mouseHov ? '#ffffff' : 'rgba(255,255,255,.8)'}"> 我要招人</span>
          </div>
          <!-- <span @click="handleSchoolDialog">高校后台</span> -->
        </div>
      </div>
    </div>
    <!-- 渠道-头部 -->
    <div v-if=" siteType == 3" class="contentBox-mainsite" :class="[isAiResumeDetail ? 'w-100' : '', isAiResumeResult ? 'dia-width' : '', isAiInterViewResult? 'w-1440' : '']">
      <div class="menuLeft">
        <!-- <img v-if="!showTitle" src="@/assets/logo-header.png" width="132px" height="36px" alt="" @click="jumpIndex('0')">
        <img v-else src="@/assets/jobfair-logo.png" width="132px" height="36px" alt="" @click="jumpIndex('0')"> -->
        <img :src="chanelbadge" alt="" @click="jumpIndex('0')" class="img-chanel" width="36px" height="36px">
        <div class="textBox">
          <p :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'">{{handlename(maintitle)}}</p>
          <p class="pingtai">{{subtitle}}</p>
        </div>
      </div>
      <div class="menuCenter">
        <div :class="{'selectText': $route.meta.activeHome == 'home'}" @click="jumpIndex('0')"><span>首页</span></div>
        <div v-if="isOpenAi == 1" :class="{'selectText': $route.meta.activeHome == 'aiResume', 'public_menu_box': true}" @mouseenter="isAiResumeShowMenu = true" @mouseleave="isAiResumeShowMenu = false">
          <span>AI简历</span>
          <div v-if="isAiResumeShowMenu" :class="['p_down_menu animate__animated', isAiResumeShowMenu ? 'animate__fadeIn' : 'fadeOut']">
            <span class="row_menu" @click="jumpIndex('3')">AI智写简历</span>
            <span class="row_menu" @click="jumpIndex('4')">AI简历诊断</span>
          </div>
        </div>
        <div v-if="is_ai_interview == 1" :class="{'selectText': $route.meta.activeHome == 'interviewRoom'}" @click="jumpIndex('5')"><span>AI模拟面试<p class="icon_box">Beta</p></span></div>
        <div v-if="catalogue.position_recommend == 1 " :class="{'selectText': $route.meta.activeHome == 'jobRecommend'}" @click="jumpIndex('1')"><span>职位推荐</span></div>
        <div v-if="catalogue.company_show_all == 1 " :class="{'selectText': $route.meta.activeHome == 'company'}" @click="jumpIndex('2')"><span>企业</span></div>
      </div>
      <div class="menuRight">
        <div class="myResume" :class="{'selectText': false}" @click="jumpMyResume()">我的简历</div>
        <div v-if="!isShowPortrait" class="loginBox">
          <div @click="handleLogin('')">登录/注册</div>
        </div>
        <div v-else class="headPortrait" @mouseover="isShowOutBox = true" @mouseout="isShowOutBox = false">
          <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
          <div class="my-dialog-box" v-show="isShowOutBox">
            <div class="my-basic-info">
              <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
              <span class="name">{{userName}}</span>
            </div>
            <div class="my-function">
              <div class="public-box" @click="jumpDeliveryFeedback">
                <span class="public-icon"></span>
                <span class="name">投递反馈</span>
              </div>
              <div class="public-box" @click="interviewDialogVisible = true">
                <span class="public-icon2"></span>
                <span class="name">我的面试</span>
              </div>
              <div class="public-box" @click="jumpMyCollect">
                <span class="public-icon3"></span>
                <span class="name">我的收藏</span>
              </div>
            </div>
            <div class="backBox" @click="handleBack">
<!--              <i class="iconfont icon-jyyrtuichu"></i>-->
              <span>退出登录</span>
            </div>
          </div>
        </div>
        <!-- <div class="logoinEntr" v-if="$route.meta.isOtherLoginBox"> -->
        <div class="logoinEntr" >
          <span @click="handleChanelDialog" class="qdline">{{isChinaTaiWan ? '管理后台' : '主办方管理后台'}}</span>
          <div class="rightContent" style="display:flex;align-items: center;" @mousemove="handlehover" @mouseout="handleOut" @click="handleCompanyDialog">
            <!-- <img src="../../assets/qiye_hover.png" alt=""> -->
            <img v-if="mouseHov" src="../../assets/qiye_hover.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <img v-else src="../../assets/qiye_normal.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <span :style="{color: mouseHov ? '#ffffff' : 'rgba(255,255,255,.8)'}"> 我要招人</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 院系-头部 -->
    <div v-if="school_type == 2" class="contentBoxChange" :class="[isAiResumeDetail ? 'w-100' : '', isAiResumeResult ? 'dia-width' : '', isAiInterViewResult? 'w-1440' : '']">
      <div class="menuLeft">
        <img :src="schoolIcon" alt="" @click="$router.push('/')">
        <div class="textBox">
          <!-- <p style="color:rgba(255, 255, 255, .8);">{{schoolName}}</p> -->
          <p v-if="showTitle" :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'" style="color:rgba(255, 255, 255, .8)">{{handlename(schoolName)}}</p>
          <p v-else :class="normal ? 'schoolname-heaader' : 'schoolname-heaaderChange'" style="color:rgba(255, 255, 255, .8)">{{handlename(schoolName)+'站'}}</p>
          <p v-if="showTitle" class="pingtai" style="color:rgba(255, 255, 255, .8);">就业育人平台</p>
          <p v-else class="pingtai" style="color:rgba(255, 255, 255, .8);">2025届高校毕业生校园招聘系列活动</p>

        </div>
        <div class="menuCenter">
          <div class="tab-content" @click="handleJump('0')">
            <div :class="$route.meta.activeHome == 'collegePosition' ? 'tab-textClick' : 'tab-text'">职位</div>
<!--            <div v-if="!hidden && isclick" class="line"></div>-->
            <div v-if="$route.meta.activeHome == 'collegePosition'" class="line"></div>
          </div>
          <div  class="tab-content" @click="handleJump('1')">
            <div :class="$route.meta.activeHome == 'collegeCompany' ? 'tab-textClick' : 'tab-text'">企业</div>
<!--            <div v-if="!companyhidden && isclickcompamy" class="line"></div>-->
            <div v-if="$route.meta.activeHome == 'collegeCompany'" class="line"></div>
          </div>
          <div class="tab-contentjob" v-if="jobShow"  @click="handleJump('2')">
            <div :class="$route.meta.activeHome == 'collegeJobfair' ? 'tab-textClick' : 'tab-text'">{{exhibition[2].title}}</div>
<!--            <div v-if="!jobhidden && isclickjob" class="line"></div>-->
            <div v-if="$route.meta.activeHome == 'collegeJobfair'" class="line"></div>
          </div>
          <div v-if="isOpenAi == 1" class="tab-contentjob public_menu_box" style="width: 86px;" @mouseenter="isAiResumeShowMenu = true" @mouseleave="isAiResumeShowMenu = false">
            <div :class="$route.meta.activeHome == 'aiResume' ? 'tab-textClick' : 'tab-text'">AI简历</div>
<!--            <div v-if="!aiHidden && isAiResumeClick" class="line"></div>-->
            <div v-if="$route.meta.activeHome == 'aiResume'" class="line"></div>
            <div v-if="isAiResumeShowMenu" :class="['p_down_menu animate__animated', isAiResumeShowMenu ? 'animate__fadeIn' : 'fadeOut']">
              <span class="row_menu" @click="jumpIndex('3')">AI智写简历</span>
              <span class="row_menu" @click="jumpIndex('4')">AI简历诊断</span>
            </div>
          </div>
          <div v-if="is_ai_interview == 1" class="tab-content interView_ai" @click="jumpIndex('5')">
            <div :class="$route.meta.activeHome == 'interviewRoom' ? 'tab-textClick' : 'tab-text'">AI模拟面试<p class="icon_box">Beta</p></div>
            <!--            <div v-if="!hidden && isclick" class="line"></div>-->
            <div v-if="$route.meta.activeHome == 'interviewRoom'" class="line"></div>
          </div>
        </div>
      </div>
      <div class="menuRight">
        <div class="myResume" :class="{'selectText': false}" @click="jumpMyResume()">我的简历</div>
        <div v-if="!isShowPortrait" class="loginBox">
          <div @click="handleLogin('')">登录/注册</div>
        </div>
        <div v-else class="headPortrait" @mouseover="isShowOutBox = true" @mouseout="isShowOutBox = false">
          <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
          <div class="my-dialog-box" v-show="isShowOutBox">
            <div class="my-basic-info">
              <img :src="!photoImgUrl ? isManOrGirlUrl : photoImgUrl" alt="">
              <span class="name">{{userName}}</span>
            </div>
            <div class="my-function">
              <div class="public-box" @click="jumpDeliveryFeedback">
                <span class="public-icon"></span>
                <span class="name">投递反馈</span>
              </div>
              <div class="public-box" @click="interviewDialogVisible = true">
                <span class="public-icon2"></span>
                <span class="name">我的面试</span>
              </div>
              <div class="public-box" @click="jumpMyCollect">
                <span class="public-icon3"></span>
                <span class="name">我的收藏</span>
              </div>
            </div>
            <div class="backBox" @click="handleBack">
<!--              <i class="iconfont icon-jyyrtuichu"></i>-->
              <span>退出登录</span>
            </div>
          </div>
        </div>
        <div class="logoinEntr" >
          <span @click="handleSchoolDialog">院系后台</span>

          <!-- <span @click="handleCompanyDialog">我要招人</span> -->
          <div class="rightContent" style="display:flex;align-items: center;" @mousemove="handlehover" @mouseout="handleOut" @click="handleCompanyDialog">
            <!-- <img src="../../assets/qiye_hover.png" alt=""> -->
            <img v-if="mouseHov" src="../../assets/qiye_coll_hover.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <img v-else src="../../assets/qiye_coll_normal.png"  alt="" width="20px" height="20px" style="display:inline;margin-right: 4px;"></img>
            <span :style="{color: mouseHov ? '#ffffff' : 'rgba(255,255,255,.8)'}"> 我要招人</span>
          </div>
        </div>
      </div>
    </div>
    <!--  登录弹框-学生  -->
    <login-dialog :isJump="isJump" :siteType="siteType" :chanelbadge = "chanelbadge" @closeClick="handleClose('1')" v-if="loginDialogShow"></login-dialog>
    <!-- 高校   -->
    <school-login-dialog @closeClick="handleClose('2')" v-if="schoolDialogShow" @closeSchoolDialog="closeSchoolDialog"></school-login-dialog>
   <!--  企业  -->
    <company-login-dialog v-if="companyDialogShow" @closeClick="handleClose('3')" @closeCompanyDialog="closeCompanyDialog"></company-login-dialog>
    <!-- 渠道 -->
    <chanel-login-dialog v-if="chanelDailogShow" :chanelDailogShow = "chanelDailogShow"  @closeClick="handleClose('5')" @closeChanelDialog="closeChanelDialog"></chanel-login-dialog>
   <!-- 切换登录状态   -->
    <switch-login-status :switchType="'1'" v-if="stateDialogShow" @handleClose="handleClose('4')"></switch-login-status>
   <!-- 退出登录弹框   -->
    <back-login-dialog v-if="isBackShow" :backType="'0'"></back-login-dialog>
    <!--   我的面试   -->
     <el-dialog v-if="interviewDialogVisible" :append-to-body="true" align-center :close-on-click-modal="false" :visible.sync="interviewDialogVisible" top="0" :lock-scroll="true" custom-class="interview-dialog" :show-close="false">
         <my-interview-dialog :siteType="siteType" :chanelbadge = "chanelbadge" @handleClose="interviewDialogVisible = false"></my-interview-dialog>
     </el-dialog>
  </div>
</template>

<script>
  import loginDialog from '@/components/dialog/loginDialog.vue'
  import schoolLoginDialog from '@/components/dialog/schoolLoginDialog.vue'
  import companyLoginDialog from '@/components/dialog/companyLoginDialog.vue'
  import chanelLoginDialog from '@/components/dialog/chanelLoginDialog.vue'
  import Cookies from 'js-cookie'
  import { getcommon, get_detail } from "@/api/request.js"
  import {disSlide, initSlide, isStudentLogin,isSchoolLogin,isCompanyLogin,dealDefaultAvatar,isChanelLogin} from '@/utils/utils'
  import switchLoginStatus from '@/components/dialog/switchLoginStatus.vue'
  import {eventBus} from '@/utils/eventBus'
  import backLoginDialog from '@/components/dialog/backLoginDialog.vue'
  import {getSchoolData} from '@/api/indexPage'
  import myInterviewDialog from '@/components/dialog/myInterviewDialog.vue'
  import {getschoollabel,checkLogin,clearLoginData,getsiteInfo} from '@/api/indexPage'

  export default {
    props: {
      isOpenAi: {
        type: Number,
        default: 0
      },
      is_ai_interview: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loginDialogShow: false, // 学生登录弹框
        schoolDialogShow: false, // 高校后台
        companyDialogShow: false, // 企业
        chanelDailogShow:false, //渠道
        isPortraitFlag: false,  // 学生登录成功显示头像
        isShowOutBox: false, // 是否显示退出弹框
        stateDialogShow: false, // 切换登录状态
        photoImgUrl: '',  // 学生头像地址
        isJump: '',  // 1:我的简历， 2： 技能点击
        isBackShow: false,
        imgMan: require("@/assets/img_man.png"),
        imgGirl: require("@/assets/img_girl.png"),
        isManOrGirlUrl: '//img.applyoffer.com/resume/avatar/v2/default_v2.png',
        studentInfo: null,
        resume_data: null,
        selectIndex: '',
        schoolName: '',
        schoolIcon: '',
        isJYShow: false,
        isCQShow: false,
        userName: '',
        interviewDialogVisible: false,
        school_type:'',//学校类型；1.学校；2.院系
        isopen:false,
        isclick:true,
        isclickcompamy:false,
        isclickjob:false,
        exhibition:'',
        hidden:false,//取消默认选中
        companyhidden:false,
        jobhidden:false,
        jobShow:false,
        // collegeLogo:'',
        normal:false,
        reduce:false,
        siteType:'',//1：主站；2：学校；3：渠道
        showTitle:false,
        maintitle:'',
        subtitle:'',
        chanelbadge:'',
        catalogue:'',
        not_prod:'1',
        mouseHov:false,
        aiHidden: false,
        isAiResumeClick: false,
        isChinaTaiWan: false,
        isAiResumeShowMenu: false // ai简历
      }
    },
    components: {
      loginDialog,
      schoolLoginDialog,
      companyLoginDialog,
      switchLoginStatus,
      backLoginDialog,
      myInterviewDialog,
      chanelLoginDialog
    },
    async created() {
      // if(window.location.hash){
      //   if(window.location.hash.indexOf("user_id") != -1 ){
      //     let arr = window.location.hash.split('?')
      //     let idArr = arr[1].split('=')
      //     let id = idArr[2]
      //     Cookies.set('user_id',id)
      //     this.updateInfo()
      //   }

      // }
      await this.getCurrentSiteinfo()
      await this.checkLoginFn()
      if(Cookies.get('login_type') == 'student') this.isShowPortrait = Cookies.get('user_id')
      await this.getUserInfo()
      await this.refreshPhone()
      await this.initSchoolData()
      // 针对 jiuyeyuren.com/s 做访问首页学生登录弹框打开
      if(!Cookies.get('user_id') && this.$route.query.isLogin == '1') {
        this.handleLogin('1')
      }
      if(window.location.host.includes('yunnan.jiuyeyuren.com')) {
        this.isJYShow = true;
      }
      if(window.location.host.includes('chongqing.jiuyeyuren.com')) {
        this.isCQShow = true;
      }
      if(window.location.origin.split('//')[1].indexOf('jiuyeyuren') > -1 ){
        this.showTitle = true
      }
    },

    mounted() {
      console.log('====window.location.hash====', this.$route)
      if(window.location.hash.includes('jobRecommend')){
        this.selectIndex = 1
        console.log('111')
      }else if(window.location.hash.includes('companyList')){
        this.selectIndex = 2
        console.log('222')
      }else if(window.location.hash === '#/'){
        this.selectIndex = 0
        console.log('333')
      }else if(window.location.hash == ('#/resume_create')){
        this.selectIndex = ''
      }else {

        // this.selectIndex = this.$store.state.header.selectIndex
        this.selectIndex = localStorage.getItem('selectIndex')
        console.log('this.$store.state.header.selectIndex',localStorage.getItem('selectIndex'))
        console.log('444')
      }
      let hash = window.location.hash
      eventBus.$on('changeNum', () => {
            this.isclick = true
            this.isclickcompamy = false
            this.isclickjob = false
            this.selectIndex = 0
            this.isAiResumeClick = false
        // this.isShowPortrait = Cookies.get('user_id')
      })
      setTimeout(()=>{

        // console.log('this.$route.query.from',this.$route)
        if(hash.includes('/collegePosition') || this.$route.query.from == 0){
            this.isclick = true
            this.isclickcompamy = false
            this.isclickjob = false
        }else if(hash.includes('/collegeCompany') || this.$route.query.from == 1){
            this.isclickcompamy = true
            this.isclick = false
            this.isclickjob = false
        }else if(hash.includes('/collegeJobfair') || this.$route.query.from == 2){

            this.isclickjob = true
            this.isclickcompamy = false
            this.isclick = false
        }
        if(this.$route.query.from == 3 || this.$route.query.from == 4 ){
          this.hidden = true
          this.companyhidden = true
          this.jobhidden = true
        }
        // this.isclick = true
        //   this.isclickcompamy = false
        //   this.isclickjob = false
      },300)
      // console.log('zhi=====',this.isclick,this.isclickcompamy,this.isclickjob)
      // this.collegeLogo = Cookies.get('colleageLogo')
      eventBus.$on('openLoginDialog', val => {
        this.loginDialogShow = val
        this.isJump = '1'
        this.stateDialogShow = false
        this.isPortraitFlag = false
      })
      eventBus.$on('setLoginState', () => {
        this.isShowPortrait = Cookies.get('user_id')
      })
      eventBus.$on('updatePhoto', ()=> {
        this.updateInfo()
      })
      if(Cookies.get('user_id') && Cookies.get('login_type') == 'student') {
        this.updateInfo()
      }
      this.getselectLabel()
    },
    methods: {
      handlehover(){
        this.mouseHov = true
      },
      handleOut(){
        this.mouseHov = false
      },
      tologo(){
        window.location.replace('http://univ.daily.applyoffer.com/#/transferlogin')
      },
      updateInfo() {
        console.log('调用头像')
        getcommon().then(res => {
          if(res.apiStatus) {
              let data2 = {
                  user_id: Cookies.get('user_id'),
              };
              sessionStorage.setItem('studentInfo', JSON.stringify(res))
              get_detail(data2).then((res) => {
                  if (res.apiStatus) {
                      sessionStorage.setItem("resume_data", JSON.stringify(res));
                      this.getUserInfo();
                      this.refreshPhone();
                  }
              })
          }
        })
      },
      async initSchoolData() {
        try {
          // let url = window.location.origin.split('//')[1]
          // let data = {}
          // if(process.env.NODE_ENV == "development") {
          //   console.log('development')
          //   data.domain = window.location.origin.split('//')[1]
          //   //开发环境
          // } else if (process.env.NODE_ENV == "production") {
          //   //生产环境
          //   console.log('production')
          //   data.domain = ''
          //
          //
          // }else{
          //   //本地环境
          //   console.log('本地')
          // }
          const res = await getsiteInfo()
          // const res = await getSchoolData({domain: url})
          if(res.apiStatus) {
            // this.schoolName = res.school.school
            // this.schoolIcon = res.school.config.school_badge
            // this.school_type = res.school_type
            this.isChinaTaiWan = res.is_taiban == 1 ? true : false
            // sessionStorage.setItem('school_type',JSON.stringify(this.school_type))
            // sessionStorage.setItem('schoolIcon',JSON.stringify(this.schoolIcon))
            // if(this.school_type == 2){
            //   this.$router.push({ path: '/collegePosition' })
            // }
          }
        }catch (e) {
          // this.$Message.error('请求失败')
        }
      },
      refreshPhone() {
       setTimeout(() => {
         this.studentInfo = JSON.parse(sessionStorage.getItem('studentInfo'))
         this.resume_data = JSON.parse(sessionStorage.getItem('resume_data'))
         if(this.resume_data){

           this.userName = this.resume_data.name;
         }
         if(this.studentInfo && this.studentInfo.has_resume == '1') {
           if(this.resume_data && this.resume_data.sex == '0' || this.studentInfo && this.studentInfo.sex == '0') {
             this.isManOrGirlUrl = dealDefaultAvatar(Cookies.get('user_id'), 0)
             return
           }
           if(this.resume_data && this.resume_data.sex == '1' || this.studentInfo && this.studentInfo.sex == '1'){
             this.isManOrGirlUrl = dealDefaultAvatar(Cookies.get('user_id'), 1)
             return;
           }
         } else {
           if(this.resume_data && !this.resume_data.sex|| this.studentInfo && !this.studentInfo.sex){
             this.isManOrGirlUrl = '//img.applyoffer.com/resume/avatar/v2/default_v2.png'
             return;
           }
         }
       },200)
      },
      // 首页跳转
      jumpIndex(i) {
        if(i == 0){
          this.$router.push('/')
        }else if(i == 1){
          this.$router.push('/jobRecommend')
        }else if(i == 3){ // ai简历
          this.isAiResumeShowMenu = false
          this.$router.push({path:'/aiIntelligentfilling', query:{isAuth: '1'}})
          return
          if(!isStudentLogin()) { // 未登录  跳转 产品介绍页
            this.$router.push({path:'/aiIntelligentfilling', query:{isAuth: '1'}})
          }else {
            let data = JSON.parse(sessionStorage.getItem('studentInfo'))
            if ( data && data.has_resume == '1') { // 是否存在 在线简历   0：否；1：是
              this.$router.push({path: '/aiResumeDetail'})
            }else {
              // 无简历 --基本信息页
              this.$router.push({path:'/aiIntelligentfilling', query:{isAuth: '1'}})
            }
          }
        }else if(i == 4) {
          this.isAiResumeShowMenu = false
          if(!isStudentLogin()) {
            this.$router.push({path: '/aiIntroduction'})
          }else {
            let data = JSON.parse(sessionStorage.getItem('studentInfo'))
            if(data.has_resume_diagnose == '1') {
              this.$router.push(({path: '/diagnosticResult', query:{id: '', type: '1'}}))
            }else {
              this.$router.push({path: '/aiIntroduction'})
            }
          }
        }else if(i == 5) {
          this.$router.push({path: '/aiInterviewIntroduce'})
          // if(!isStudentLogin()) {
          //   this.$router.push({path: '/aiIntroduction'})
          // }else {
          //   let data = JSON.parse(sessionStorage.getItem('studentInfo'))
          //   if(data.has_resume_diagnose == '1') {
          //     this.$router.push(({path: '/diagnosticResult', query:{id: ''}}))
          //   }else {
          //     this.$router.push({path: '/aiInterviewIntroduce'})
          //   }
          // }
        }else{
          this.$router.push('/companyList')
        }
        this.selectIndex = i
        // this.$store.commit('header/setIndex',this.selectIndex)
        localStorage.setItem("selectIndex", this.selectIndex);

      },
      // 企业登录成功关闭弹框
      closeCompanyDialog() {
        this.companyDialogShow = false
        this.isShowPortrait = Cookies.get('user_id')
      },
      //  学校登录成功关闭弹框
      closeSchoolDialog() {
        this.schoolDialogShow = false
        this.isShowPortrait = Cookies.get('user_id')
      },
      closeChanelDialog(){
        this.chanelDailogShow = false
        this.isShowPortrait = Cookies.get('user_id')
      },
      handleCancel() {
        this.isBackShow = false
      },
      // 退出登录
      handleBack() {
        this.isBackShow = true
      },
      // 获取学生信息
      getUserInfo() {
        setTimeout(()=> {
          let data = JSON.parse(sessionStorage.getItem('studentInfo'))
          this.has_resume =data ? data.has_resume : '0'
          this.photoImgUrl = data ? data.avatar : ''
        },100)
      },
      // 跳转我的简历
      jumpMyResume(i) {
        // this.selectIndex = i
        localStorage.setItem('selectIndex','')
        console.log('this.selectIndex',this.selectIndex)
        window.isJumpFlag = true
        if(isSchoolLogin() || isCompanyLogin()) {
          this.stateDialogShow = true
          disSlide()
          return
        }
        if(!isStudentLogin()) {
          this.loginDialogShow = true
          this.isJump = '1'
          return
        }
        let data = JSON.parse(sessionStorage.getItem('studentInfo'))
        if ( data && data.has_resume == '1') { // 是否存在 在线简历   0：否；1：是
          const { href } = this.$router.resolve({
            path: '/resume',
            query:{
              from: 3
            }

          })
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            window.open(href, '_self')
          }else {
            window.open(href, '_blank')
          }
        } else {
          const { href } = this.$router.resolve({
            path: '/resume_create',
            query:{
              from: 3
            }
          })
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            window.open(href, '_self')
          }else {
            window.open(href, '_blank')
          }
        }
      },
      // 登录注册弹框
      handleLogin(val) {
        console.log('===============', this.$route, this.$router)
        window.isJumpFlag = true
        this.isJump = this.$route.path == '/aiInterviewIntroduce' ? '11' : val
        this.loginDialogShow = true
        disSlide()
      },
      // 高校后台
      handleSchoolDialog() {
        if (isSchoolLogin()) {
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            // window.location.href = `${window.location.origin}/school/#/dashboard`
            window.open(`${window.location.origin}/school/#/dashboard`)
          } else {
            window.open(`${window.location.origin}/school/#/dashboard`)
          }
        } else {
          this.schoolDialogShow = true
          disSlide()
        }
      },
      // 企业入口
      handleCompanyDialog() {
        if (isCompanyLogin()) {
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            // window.location.href = `${window.location.origin}/company/#/`
            window.open(`${window.location.origin}/company/#/`)
          } else {
            window.open(`${window.location.origin}/company/#/`)
          }
          // window.open(`${window.location.origin}/company/#/`);
          // window.open(`http://company.dev.applyoffer.com:8081/`);
          // window.open(`https://qiye.biyeshen.cn/#/`)
          // window.open(`http://company.daily.applyoffer.com/`)
        } else {
          this.companyDialogShow = true
          disSlide()
        }
      },
      //渠道-主办方管理后台入口
      handleChanelDialog(){
        // isChanelLogin
        if (isChanelLogin()) {
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            // window.location.href = `${window.location.origin}/op/#/schoolBroad/index`
            window.open(`${window.location.origin}/op/#/schoolBroad/index`)
          } else {
            window.open(`${window.location.origin}/op/#/schoolBroad/index`)
          }
          // window.open(`${window.location.origin}/company/#/`);
          // window.open(`http://company.dev.applyoffer.com:8081/`);
          // window.open(`https://qiye.biyeshen.cn/#/`)
          // window.open(`http://company.daily.applyoffer.com/`)
        } else {
          this.chanelDailogShow = true
          disSlide()
        }
      },
      // 主站企业入口
      handleCompanyMainsite(){

        // if(process.env.NODE_ENV == "development") {
        //   console.log('development')
        //   window.open(`https://qiye.daily.applyoffer.com/#/`,'_blank')

        //   //开发环境
        // } else if (process.env.NODE_ENV == "production") {
        //   //生产环境
        //   console.log('production')
        //   window.open(`https://qiye.biyeshen.cn/#/`,'_blank')



        // }else{
        //   window.open(`https://qiye.biyeshen.cn/#/`,'_blank')
        // }
        if(this.not_prod == 1){
          window.open(`https://qiye.daily.applyoffer.com/#/`,'_blank')
        }else{
          window.open(`https://qiye.biyeshen.cn/#/`,'_blank')
        }
      },
      // 关闭弹窗
      handleClose(type) {
        initSlide()
        switch (type) {
          case '1':
            this.loginDialogShow = false
            this.isShowPortrait = Cookies.get('user_id')
            this.getUserInfo()
            this.refreshPhone()
                break
          case '2':
            this.schoolDialogShow = false
                break
          case '3':
            this.companyDialogShow = false
                break
          case '4':
            this.stateDialogShow = false
                break
          case '5':
            this.chanelDailogShow = false
                break
        }
      },
      jumpDeliveryFeedback() {
        // console.log('----点击投递反馈------')
          localStorage.setItem('selectIndex','')
          const { href } = this.$router.resolve({
              path: '/deliveryFeedback',
              query:{
                from: 3 // 1企业 2 双选会 3.我的收藏 4.投递反馈
              }
          })
          window.open(href, '_blank')
      },
      jumpMyCollect() {
          localStorage.setItem('selectIndex','')
          const { href } = this.$router.resolve({
              path: '/myCollect',
              query:{
                from: 3 // 1企业 2 双选会 3.我的收藏 4.投递反馈
              }
          })
          window.open(href, '_blank')
      },
      handleJump(i){
        if(i == 0){
          this.hidden = false
          this.isclick = true
          this.isclickcompamy = false
          this.isclickjob = false
          this.isAiResumeClick = false
          this.$router.push({
            path: '/collegePosition',
            query: {
              from: 0,
            },
          })

        }else if(i == 1){
          this.companyhidden = false
          this.isclickcompamy = true
          this.isclick = false
          this.isclickjob = false
          this.isAiResumeClick = false
          this.$router.push({
            path: '/collegeCompany',
            query: {
              from: 1,
            }
           })
        }else if(i == 2) {
          this.jobhidden = false
          this.isclickjob = true
          this.isclickcompamy = false
          this.isAiResumeClick = false
          this.isclick = false
          this.$router.push({
            path: '/collegeJobfair',
            query: {
              from: 2,
            }
          })

        }else if(i == 3) {
          console.log(13333333333333333333);

          this.aiHidden = false
          this.isAiResumeClick = true
          this.isclick = false
          this.isclickcompamy = false
          this.isclickjob = false
          this.$router.push('/aiIntelligentfilling')
          return
          if(!isStudentLogin()) { // 未登录  跳转 产品介绍页
            this.$router.push('/aiIntelligentfilling')
          }else {
            let data = JSON.parse(sessionStorage.getItem('studentInfo'))
            if ( data && data.has_resume == '1') { // 是否存在 在线简历   0：否；1：是
              this.$router.push({path: '/aiResumeDetail'})
            }else {
              // 无简历 --基本信息页
              this.$router.push('/aiIntelligentfilling')
            }
          }
        }
      },
      getselectLabel(){
        let data = {
          domain:window.location.origin.split('//')[1]
        }

         getschoollabel(data).then((res) => {
          if(res.exhibition){

            this.exhibition = JSON.parse(res.exhibition)
            this.jobShow = this.exhibition[2].show
          }
          // this.collegeLogo = res.domainData.head_img_url
        })
      },
      async  checkLoginFn(){
        // 三个未登录、学生登录 请求接口
        // console.log('---Cookies.get(user_id)------',Cookies.get('user_id'),!Cookies.get('user_id'))
        // console.log('!Cookies.get(com_key_user)',Cookies.get('com_key_user'),!Cookies.get('com_key_user'))
        // console.log('Cookies.get(login_type)',Cookies.get('login_type'))
        // console.log('student',Cookies.get('login_type') == 'student')
        // console.log('school',Cookies.get('login_type') == 'school')

        console.log('验证是否登录')

        // 学生已登录，状态和后端校验同步  无任何用户登录，查询后端是否有学生登录，有则同步
        // if(((!Cookies.get('user_id') && Cookies.get('login_type') == 'student') && !Cookies.get('com_key_user') && (!Cookies.get('user_id') && Cookies.get('login_type') == 'school')) || (Cookies.get('user_id') && Cookies.get('login_type') == 'student')){
        if((!Cookies.get('user_id') && !Cookies.get('com_key_user') && !Cookies.get('channel_userid')) || (Cookies.get('user_id') && Cookies.get('login_type') == 'student')){

          let data ={}
          data.user_id = Cookies.get('user_id') ? Cookies.get('user_id') : ''
          await checkLogin(data).then((res)=>{
            if(res.user_id && res.user_id != 0){
              Cookies.set('user_id',res.user_id,{expires:14})
              Cookies.set('login_type','student',{expires:14})
              this.updateInfo()
              this.isShowPortrait = Cookies.get('user_id')

            }else if(res.code == 10008){
              this.clearLoginDataFn()
            }else if(res.user_id == 0){
            }
          })
        }

      },
      async clearLoginDataFn(){
        // clearLoginData().then(()=>{

        // })
        const res = await clearLoginData()
        Cookies.remove('user_id')
        Cookies.remove('com_key_user')
        Cookies.remove('login_type')
        Cookies.remove('resume_data')
        sessionStorage.removeItem('studentInfo')
        sessionStorage.removeItem('resume_data')


      },
      async getCurrentSiteinfo(){
        let data = {}
        // data.domain = '',
        if(process.env.NODE_ENV == "development") {
          console.log('development')
          data.domain = window.location.origin.split('//')[1]
          //开发环境
        } else if (process.env.NODE_ENV == "production") {
          //生产环境
          console.log('production')
          data.domain = ''


        }else{
          //本地环境
          console.log('本地')
        }
        await getsiteInfo(data).then((res)=>{
          console.log('==10.9==',res)
          this.siteType = res.type
          this.catalogue = res.catalogue
          if(res.not_prod){
            this.not_prod = res.not_prod
          }else{
            this.not_prod = '2'
          }

          if(res.school.length != 0 ){
            this.schoolName = res.school.school
            this.schoolIcon = res.school.config.school_badge
            this.school_type = res.school.school_type
            // this.catalogue = res.catalogue
            // console.log('===this.catalogue',this.catalogue)
            sessionStorage.setItem('school_type',JSON.stringify(this.school_type))
            sessionStorage.setItem('schoolIcon',JSON.stringify(this.schoolIcon))
          }
          if(res.channel.length != 0){
            this.maintitle = res.channel.title
            this.subtitle = res.channel.subtitle
            this.chanelbadge = res.channel.badge
          }
        })
      },

      closeChanelClick(){
        this.chanelDailogShow = false
      },
      handlePositionRefresh(){
        this.updateInfo()
        this.isShowPortrait = Cookies.get('user_id')
        eventBus.$emit('jobList')
        eventBus.$emit('jobwantPosi')
      }

    },
    computed: {
      isFixed () {
        return this.$store.state.header.isHeaderFixed
      },
      isShowPortrait: {
        get: function() {
          return this.isPortraitFlag
        },
        set: function(newVal) {
          newVal ? this.isPortraitFlag = true : this.isPortraitFlag = false
        }
      },
      isAiResumeDetail() {
        return this.$route.path == '/aiResumeDetail'
      },
      isAiResumeResult() {
        return this.$route.path == '/diagnosticResult'
      },
      isAiInterViewResult() {
        return this.$route.path == '/aiInterviewResult'
      },

      handlename(){
        return function(val){
          if(val.length <= 20){
            this.normal = true
            this.reduce = false
          }if(val.length > 20){
            this.normal = false
            this.reduce = true
          }
          // if( this.siteType == 2){
          //   //学校
          //   return val+'站'
          // }else{

          // }
          return val
        }
      }
    },
    destroyed() {
        eventBus.$off();
    }
  }
</script>

<style lang="less" scoped>
    @import '../../assets/globalStyle/reset-element.less';
  .isHeaderFixed {
    position: fixed;
    top: 0;
    left: 0;
    // z-index: 9;
    z-index: 10;
  }
  .navBox {
    height: 60px;
    width: 100%;
    // background-color: @color-header-background;
    .contentBox {
      &.w-100 {
        width: 100%;
        padding: 0 40px;
      }
      width: 1200px;
      height: 100%;
      color: #FFFFFF;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menuLeft {
        // width: 252px;
        display: flex;
        margin-right: 44px;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
        img:hover {
          cursor: pointer;
        }
        .textBox {
          margin-left: 8px;
          letter-spacing: 1px;
          // & p:first-child {
          //   // width: 208px;
          //   font-size: 14px;
          //   line-height: 16px;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          //   white-space:nowrap;
          // }
          // & p:last-child {
          //   font-size: 12px;
          //   line-height: 14px;
          //   margin-top: 8px;
          //   color: rgba(255,255,255,0.85);
          // }
          .schoolname-heaader{
            // width: 208px;
            font-size: 14px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
          .schoolname-heaaderChange{
            max-width: 296px;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
          .pingtai{
            font-size: 12px;
            line-height: 14px;
            margin-top: 8px;
            color: rgba(255,255,255,0.85);
            max-width: 296px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
        }
      }

      .menuCenter {
        flex: 1;
        display: flex;
        font-size: 16px;
        // color: #FFFFFF;
        color: rgba(255,255,255,0.8);
        line-height: 21px;
        height: 100%;
        align-items: center;
        div {
          // min-width: 56px;
          // height: 32px;
          // line-height: 32px;
          span {
            display: flex;
            padding: 8px 12px;

            // height: 32px;
            // line-height: 32px;
            text-align: center;
            p {
              width: 38px;
              height: 18px;
              background: #5F8DFF;
              border-radius: 9px 9px 9px 1px;
              margin-left: 6px;
              font-size: 12px;
              color: rgba(255,255,255,0.9);
              line-height: 16px;
            }
          }
          margin-right: 8px;
        }
        div:hover {
          span {
            background: rgba(0,0,0,0.1);
            color: #FFFFFF;
            border-radius: 4px;
            cursor: pointer;
          }
        }
        .public_menu_box {
          position: relative;
          height: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          .p_down_menu {
            position: absolute;
            bottom: -88px;
            left: 0;
            width: 134px;
            height: 88px;
            background: #FFFFFF;
            border-radius: 6px;
            z-index: 9999;
            filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.2));
            padding: 8px;
            box-sizing: border-box;

            .row_menu {
              height: 36px;
              background: rgba(53,111,250,0);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              color: #515A6E;
              line-height: 19px;
              font-weight: normal !important;

              &:hover {
                background: #F6F7F9;
                border-radius: 4px;
                color: #356FFA;
              }
            }
          }
        }
      }

      .menuCenterChange{
        display: flex;
      }

      .menuRight {
        display: flex;
        align-items: center;
        .myResume {
          font-size: 14px;
          margin-right: 12px;
          color: rgba(255,255,255,0.8);
        }
        .myResume:hover {
          cursor: pointer;
          color: rgba(255,255,255,1);
        }
        .loginBox {
          & div:first-child {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            border: 1px solid rgba(255,255,255,0.4 );
            border-radius: 4px;
            color: rgba(255,255,255,0.8);
          }
          & div:first-child:hover {
            color: rgba(255,255,255,1);
            border-color: rgba(255,255,255,1);
            cursor: pointer;
          }
        }
        .headPortrait {
          width: 40px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          position: relative;
          // z-index: 10;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid #B8D5FA;
            vertical-align: middle;
            object-fit: cover
          }
          .my-dialog-box {
            width: 286px;
            background: #FFFFFF;
            box-shadow: 0px 2px 4px 0px #D6D6D6;
            border-radius: 4px;
            position: absolute;
            top: 59px;
            right: 0;
            // z-index: 9;
            z-index: 10;

            &:hover {
              cursor: default;
            }

            .my-basic-info {
              height: 64px;
              width: 100%;
              background: #E6F0FF url("../../assets/collectAndMy/img-my-center.png") bottom right no-repeat;
              background-size: 56px 48px;
              display: flex;
              align-items: center;
              padding-left: 31px;
              box-sizing: border-box;
              img {
                width: 38px;
                height: 38px;
                margin-right: 11px;
              }
              .name {
                display: inline-block;
                font-size: 16px;
                font-weight: bold;
                color: #17306D;
                line-height: 21px;
                max-width: 144px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .my-function {
              height: 111px;
              display: flex;
              align-items: center;
              padding: 0 32px;
              box-sizing: border-box;
              .public-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 27px;
                cursor: pointer;
                &:last-child {
                  margin-right: 0;
                }
                span {
                  display: inline-block;
                }
                .public-icon {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/deliver_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon2 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/interview_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon3 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/collect_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .name {
                  font-size: 14px;
                  color: #515A6E;
                  line-height: 19px;
                  margin-top: 4px;
                }
                &:hover {
                  .public-icon {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/deliver_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon2 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/interview_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon3 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/collect_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                   .name {
                     color: @color-font-size;
                   }
                }
                &:active {
                  .name {
                    color: @color-font-size-active;
                  }
                }
              }
            }

            .backBox {
              height: 48px;
              background: #FFFFFF;
              box-shadow: inset 0px 1px 0px 0px #EDEFF3;
              border-radius: 0px 0px 4px 4px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding-right: 32px;
              box-sizing: border-box;
              cursor: pointer;
              span {
                display: inline-block;
                font-size: 13px;
                line-height: 17px;
                color:  #808695;
                display: inline-block;
                &:hover {
                  color: @color-font-size;
                }
                &:active {
                  color: @color-font-size-active;
                }
              }
            }
            /*.backBox:before {*/
            /*  content: '';*/
            /*  display: inline-block;*/
            /*  width: 0;*/
            /*  height: 0;*/
            /*  border-left: 5px solid transparent;*/
            /*  border-right: 5px solid transparent;*/
            /*  border-top: 5px solid transparent;*/
            /*  border-bottom: 5px solid #FFFFFF;*/
            /*  position: absolute;*/
            /*  top: -10px;*/
            /*  right: 10px;*/
            /*}*/
          }
        }
        .logoinEntr {
          margin-left: 30px;
          font-size: 14px;
          line-height: 19px;
          display: flex;
          align-items: center;
          color: rgba(255,255,255,0.8);
          & span:first-child:after {
            content: '';
            width: 1px;
            height: 9px;
            border-left: 1px solid #FFFFFF;
            margin: 0 8px;
            display: inline-block;
          }
          span:hover {
            cursor: pointer;
            color: rgba(255,255,255,1);
          }
        }
      }

      .selectText {
        font-weight: bold;
        color:  #FFFFFF!important;
      }
    }

    .contentBoxChange {
      &.w-100 {
        width: 100%;
        padding: 0 40px;
      }
      &.dia-width {
        width: calc(50% + 672px);
      }
      &.w-1440 {
        width: 1440px;
        padding: 0 24px;
        box-sizing: border-box;
      }
      width: 1200px;
      height: 100%;
      color: #17233D;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menuLeft {
        // width: 252px;
        // width: 484px;
        height: 38px;
        display: flex;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
        img:hover {
          cursor: pointer;
        }
        .textBox {
          margin-left: 8px;
          letter-spacing: 1px;
          // & p:first-child {
          //   width: 208px;
          //   font-size: 14px;
          //   line-height: 16px;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          //   white-space:nowrap;
          // }
          // & p:last-child {
          //   font-size: 12px;
          //   line-height: 14px;
          //   margin-top: 8px;
          //   // color: rgba(255,255,255,0.85);
          //   color: #808695;
          // }
          .schoolname-heaader{
            // width: 208px;
            font-size: 14px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
          .schoolname-heaaderChange{
            max-width: 296px;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
            color: #808695;
          }
          .pingtai{
            font-size: 12px;
            line-height: 14px;
            margin-top: 8px;
            color: rgba(255,255,255,0.85);
          }
        }
        .menuCenter {
          flex: 1;
          font-size: 16px;
          color: #17233D;
          line-height: 21px;
          display: flex;
          margin-left: 44px;
          .tab-content{
            width: 56px;
            height: 46px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 4px;
            &.interView_ai {
              width: 100px;
              .tab-textClick {
                display: flex;
                position: relative;
                p {
                  position: absolute;
                  right: -46px;
                  top: 3px;
                  width: 38px;
                  height: 18px;
                  background: #5F8DFF;
                  border-radius: 9px 9px 9px 1px;
                  font-size: 12px;
                  color: rgba(255,255,255,0.9);
                  line-height: 16px;
                }
              }
              .tab-text {
                display: flex;
                position: relative;
                p {
                  position: absolute;
                  right: -46px;
                  top: 3px;
                  width: 38px;
                  height: 18px;
                  background: #5F8DFF;
                  border-radius: 9px 9px 9px 1px;
                  font-size: 12px;
                  color: rgba(255,255,255,0.9);
                  line-height: 16px;
                }
              }
            }
            .tab-text {
              height: 32px;
              line-height: 32px;
              // color: #17233D;
              // color: #FFFFFF;
              color:rgba(255, 255, 255, .8)

            }
            .tab-text:hover{
              height: 32px;
              line-height: 32px;
              // color: #17233D;
              color: #FFFFFF;
            }
            .tab-textClick {
              height: 32px;
              line-height: 32px;
              font-weight: bold;
              // color: #356FFA;
              color:#FFFFFF;

            }
            .line{
              width: 28px;
              height: 4px;
              margin-top: 6px;
              // background: #356FFA;
              background: #FFFFFF;
              border-radius: 2px;
            }
          }
          .tab-content:hover {
            cursor: pointer;
          }
          .public_menu_box {
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;

            .p_down_menu {
              position: absolute;
              bottom: -88px;
              left: 0;
              width: 134px;
              height: 88px;
              background: #FFFFFF;
              border-radius: 6px;
              z-index: 9999;
              filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.2));
              padding: 8px;
              box-sizing: border-box;

              .row_menu {
                height: 36px;
                background: rgba(53,111,250,0);
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #515A6E;
                line-height: 19px;
                font-weight: normal !important;

                &:hover {
                  background: #F6F7F9;
                  border-radius: 4px;
                  color: #356FFA;
                }
              }
            }
          }
          .tab-contentjob{
            width: 72px;
            height: 46px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 4px;
            .tab-text {
              height: 32px;
              line-height: 32px;
              // color: #17233D;
              // color: #FFFFFF;
              color:rgba(255, 255, 255, .8)



            }
            .tab-text:hover{
              height: 32px;
              line-height: 32px;
              // color: #17233D;
              color: #FFFFFF;
            }
            .tab-textClick {
              height: 32px;
              line-height: 32px;
              font-weight: bold;
              // color: #356FFA;
              color: #FFFFFF;


            }
            .line{
              width: 40px;
              height: 4px;
              margin-top: 6px;
              background: #FFFFFF;
              color: #FFFFFF;

              border-radius: 2px;
            }
          }
          .tab-contentjob:hover {
            cursor: pointer;
          }
        }
      }



      .menuRight {
        display: flex;
        align-items: center;
        .myResume {
          font-size: 14px;
          margin-right: 12px;
          color: rgba(255,255,255,0.8);
          // color: #515A6E;
          // color: #FFFFFF;
        }
        .myResume:hover {
          cursor: pointer;
          color: #FFFFFF;
        }
        .loginBox {
          & div:first-child {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            // border: 1px solid rgba(255,255,255,0.4 );
            border: 1px solid #E8EAEC;

            border-radius: 4px;
            color: rgba(255,255,255,0.8);
            // color: #515A6E;
            // color: #FFFFFF;
          }
          & div:first-child:hover {
            color: rgba(255,255,255,1);
            // border-color: rgba(255,255,255,1);
            cursor: pointer;
          }
        }
        .headPortrait {
          width: 40px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          position: relative;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid #B8D5FA;
            vertical-align: middle;
            object-fit: cover
          }
          .my-dialog-box {
            width: 286px;
            background: #FFFFFF;
            box-shadow: 0px 2px 4px 0px #D6D6D6;
            border-radius: 4px;
            position: absolute;
            top: 59px;
            right: 0;
            // z-index: 9;
            z-index: 10;
            &:hover {
              cursor: pointer;
            }

            .my-basic-info {
              height: 64px;
              width: 100%;
              background: #E6F0FF url("../../assets/collectAndMy/img-my-center.png") bottom right no-repeat;
              background-size: 56px 48px;
              display: flex;
              align-items: center;
              padding-left: 31px;
              box-sizing: border-box;
              img {
                width: 38px;
                height: 38px;
                margin-right: 11px;
              }
              .name {
                display: inline-block;
                font-size: 16px;
                font-weight: bold;
                color: #17306D;
                line-height: 21px;
                max-width: 144px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .my-function {
              height: 111px;
              display: flex;
              align-items: center;
              padding: 0 32px;
              box-sizing: border-box;
              .public-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 27px;
                cursor: pointer;
                &:last-child {
                  margin-right: 0;
                }
                span {
                  display: inline-block;
                }
                .public-icon {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/deliver_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon2 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/interview_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon3 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/collect_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .name {
                  font-size: 14px;
                  color: #515A6E;
                  line-height: 19px;
                  margin-top: 4px;
                }
                &:hover {
                  .public-icon {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/deliver_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon2 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/interview_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon3 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/collect_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                   .name {
                     color: @color-font-size;
                   }
                }
                &:active {
                  .name {
                    color: @color-font-size-active;
                  }
                }
              }
            }

            .backBox {
              height: 48px;
              background: #FFFFFF;
              box-shadow: inset 0px 1px 0px 0px #EDEFF3;
              border-radius: 0px 0px 4px 4px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding-right: 32px;
              box-sizing: border-box;
              cursor: pointer;
              span {
                display: inline-block;
                font-size: 13px;
                line-height: 17px;
                color:  #808695;
                display: inline-block;
                &:hover {
                  color: @color-font-size;
                }
                &:active {
                  color: @color-font-size-active;
                }
              }
            }
            /*.backBox:before {*/
            /*  content: '';*/
            /*  display: inline-block;*/
            /*  width: 0;*/
            /*  height: 0;*/
            /*  border-left: 5px solid transparent;*/
            /*  border-right: 5px solid transparent;*/
            /*  border-top: 5px solid transparent;*/
            /*  border-bottom: 5px solid #FFFFFF;*/
            /*  position: absolute;*/
            /*  top: -10px;*/
            /*  right: 10px;*/
            /*}*/
          }
        }
        .logoinEntr {
          margin-left: 30px;
          font-size: 14px;
          line-height: 19px;
          display: flex;
          align-items: center;
          color: rgba(255,255,255,0.8);
          // color: #515A6E;
          // color: #FFFFFF;
          & span:first-child:after {
            content: '';
            width: 1px;
            height: 9px;
            border-left: 1px solid #FFFFFF;
            margin: 0 8px;
            display: inline-block;
          }
          span:hover {
            cursor: pointer;
            color: rgba(255,255,255,1);
          }
        }
      }

      .selectText {
        font-weight: bold;
        color:  #FFFFFF!important;
      }
    }

    .contentBox-mainsite {
      &.w-100 {
        width: 100%;
        padding: 0 40px;
      }
      &.dia-width {
        width: calc(50% + 672px);
      }
      &.w-1440 {
        width: 1440px;
        padding: 0 24px;
        box-sizing: border-box;
      }
      width: 1200px;
      height: 100%;
      // color: #FFFFFF;
      color: rgba(255,255,255,0.8) !important;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menuLeft {
        // width: 252px;
        display: flex;
        margin-right: 96px;
        img {
          width:132px;
          height: 36px;
        }
        .img-chanel{
          width:36px;
          height: 36px;
          border-radius: 50%;
        }
        img:hover {
          cursor: pointer;
        }
        .textBox {
          margin-left: 8px;
          letter-spacing: 1px;
          // & p:first-child {
          //   // width: 208px;
          //   font-size: 14px;
          //   line-height: 16px;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          //   white-space:nowrap;
          // }
          // & p:last-child {
          //   font-size: 12px;
          //   line-height: 14px;
          //   margin-top: 8px;
          //   color: rgba(255,255,255,0.85);
          // }
          .schoolname-heaader{
            // width: 208px;
            font-size: 14px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
          .schoolname-heaaderChange{
            max-width: 296px;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
          }
          .pingtai{
            font-size: 12px;
            line-height: 14px;
            margin-top: 8px;
            color: rgba(255,255,255,0.85);
          }
        }
      }

      .menuCenter {
        flex: 1;
        display: flex;
        font-size: 16px;
        // color: #FFFFFF;
        color: rgba(255,255,255,0.8);

        line-height: 21px;
        height: 100%;
        align-items: center;
        div {
          // width: 56px;
          // min-width: 56px;
          margin-right: 8px;
         span {
           display: flex;
           padding: 8px 12px;

           // height: 32px;
           // line-height: 32px;
           text-align: center;

           p {
             width: 38px;
             height: 18px;
             background: #5F8DFF;
             border-radius: 9px 9px 9px 1px;
             margin-left: 6px;
             font-size: 12px;
             color: rgba(255,255,255,0.9);
             line-height: 16px;
           }
         }
        }
        div:hover {
          span {
            background: rgba(0,0,0,0.1);
            color: #FFFFFF;
            border-radius: 4px;
            cursor: pointer;
          }
        }
        .public_menu_box {
          position: relative;
          height: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          .p_down_menu {
            position: absolute;
            bottom: -88px;
            left: 0;
            width: 134px;
            height: 88px;
            background: #FFFFFF;
            border-radius: 6px;
            z-index: 9999;
            filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.2));
            padding: 8px;
            box-sizing: border-box;

            .row_menu {
              height: 36px;
              background: rgba(53,111,250,0);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              color: #515A6E;
              line-height: 19px;
              font-weight: normal;

              &:hover {
                background: #F6F7F9;
                border-radius: 4px;
                color: #356FFA;
              }
            }
          }
        }
      }

      .menuCenterChange{
        display: flex;
      }

      .menuRight {
        display: flex;
        align-items: center;
        justify-content: center;
        .myResume {
          font-size: 14px;
          margin-right: 12px;
          color: rgba(255,255,255,0.8);
        }
        .myResume:hover {
          cursor: pointer;
          color: rgba(255,255,255,1);
        }
        .loginBox {
          & div:first-child {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            border: 1px solid rgba(255,255,255,0.4 );
            border-radius: 4px;
            color: rgba(255,255,255,0.8);
          }
          & div:first-child:hover {
            color: rgba(255,255,255,1);
            border-color: rgba(255,255,255,1);
            cursor: pointer;
          }
        }
        .headPortrait {
          width: 40px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          position: relative;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid #B8D5FA;
            vertical-align: middle;
            object-fit: cover
          }
          .my-dialog-box {
            width: 286px;
            background: #FFFFFF;
            box-shadow: 0px 2px 4px 0px #D6D6D6;
            border-radius: 4px;
            position: absolute;
            top: 59px;
            right: 0;
            // z-index: 9;
            z-index: 10;
            &:hover {
              cursor: pointer;
            }

            .my-basic-info {
              height: 64px;
              width: 100%;
              background: #E6F0FF url("../../assets/collectAndMy/img-my-center.png") bottom right no-repeat;
              background-size: 56px 48px;
              display: flex;
              align-items: center;
              padding-left: 31px;
              box-sizing: border-box;
              img {
                width: 38px;
                height: 38px;
                margin-right: 11px;
              }
              .name {
                display: inline-block;
                font-size: 16px;
                font-weight: bold;
                color: #17306D;
                line-height: 21px;
                max-width: 144px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .my-function {
              height: 111px;
              display: flex;
              align-items: center;
              padding: 0 32px;
              box-sizing: border-box;
              .public-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 27px;
                cursor: pointer;
                &:last-child {
                  margin-right: 0;
                }
                span {
                  display: inline-block;
                }
                .public-icon {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/deliver_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon2 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/interview_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .public-icon3 {
                  width: 24px;
                  height: 24px;
                  background: url("../../assets/collectAndMy/collect_nor.png") center no-repeat;
                  background-size: 100% 100%;
                }
                .name {
                  font-size: 14px;
                  color: #515A6E;
                  line-height: 19px;
                  margin-top: 4px;
                }
                &:hover {
                  .public-icon {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/deliver_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon2 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/interview_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                  .public-icon3 {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/collectAndMy/collect_sel.png") center no-repeat;
                    background-size: 100% 100%;
                  }
                   .name {
                     color: @color-font-size;
                   }
                }
                &:active {
                  .name {
                    color: @color-font-size-active;
                  }
                }
              }
            }

            .backBox {
              height: 48px;
              background: #FFFFFF;
              box-shadow: inset 0px 1px 0px 0px #EDEFF3;
              border-radius: 0px 0px 4px 4px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding-right: 32px;
              box-sizing: border-box;
              cursor: pointer;
              span {
                display: inline-block;
                font-size: 13px;
                line-height: 17px;
                color:  #808695;
                display: inline-block;
                &:hover {
                  color: @color-font-size;
                }
                &:active {
                  color: @color-font-size-active;
                }
              }
            }
            /*.backBox:before {*/
            /*  content: '';*/
            /*  display: inline-block;*/
            /*  width: 0;*/
            /*  height: 0;*/
            /*  border-left: 5px solid transparent;*/
            /*  border-right: 5px solid transparent;*/
            /*  border-top: 5px solid transparent;*/
            /*  border-bottom: 5px solid #FFFFFF;*/
            /*  position: absolute;*/
            /*  top: -10px;*/
            /*  right: 10px;*/
            /*}*/
          }
        }
        .logoinEntr {
          margin-left: 30px;
          font-size: 14px;
          line-height: 19px;
          display: flex;
          align-items: center;
          color: rgba(255,255,255,0.8);
          & span:first-child:after {
            content: '';
            width: 1px;
            height: 9px;
            // border-left: 1px solid #FFFFFF;
            margin: 0 8px;
            display: inline-block;
          }
          span:hover {
            cursor: pointer;
            color: rgba(255,255,255,1);
          }
          .qdline:after{
            border-left: 1px solid #FFFFFF;

          }
          .rightContent:hover{
            cursor: pointer;
            span {
              color: rgba(255,255,255,1);
            }
          }
        }
      }

      .selectText {
        font-weight: bold;
        color:  #FFFFFF!important;
      }
    }
  }
  /deep/ .el-dialog.interview-dialog {
      width: 694px;
      background: #FFFFFF;
      border-radius: 8px;
      margin: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .el-dialog__header {
        padding: 0;
      }
      .el-dialog__body {
        padding: 0
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/newHeader.vue